import React from "react";
export default function SVGManual() {
  return (
    <svg x="0px" y="0px" viewBox="0 0 512 512">
      <g>
        <g fill="#000000">
          <path d="M436,60h-15V45c0-24.813-20.187-45-45-45H76C51.187,0,31,20.187,31,45v362c0,24.813,20.187,45,45,45h15v15    c0,24.813,20.187,45,45,45h300c24.813,0,45-20.187,45-45V105C481,80.187,460.813,60,436,60z M104.18,115.607    C95.68,124.106,91,135.406,91,147.426V422H76c-8.271,0-15-6.729-15-15V45c0-8.271,6.729-15,15-15h300c8.271,0,15,6.729,15,15v15    H178.426c-12.02,0-23.32,4.681-31.819,13.18L104.18,115.607z M181,90v60h-60v-2.574c0-4.006,1.56-7.773,4.393-10.606    l42.427-42.427c2.833-2.833,6.6-4.393,10.606-4.393H181z M451,467c0,8.271-6.729,15-15,15H136c-8.271,0-15-6.729-15-15V180h75    c8.284,0,15-6.716,15-15V90h225c8.271,0,15,6.729,15,15V467z" />
        </g>
      </g>
      <g>
        <g fill="#000000" opacity="0.5">
          <path d="M406,212H166c-8.284,0-15,6.716-15,15s6.716,15,15,15h240c8.284,0,15-6.716,15-15S414.284,212,406,212z" />
        </g>
      </g>
      <g>
        <g fill="#000000" opacity="0.5">
          <path d="M406,272H166c-8.284,0-15,6.716-15,15s6.716,15,15,15h240c8.284,0,15-6.716,15-15S414.284,272,406,272z" />
        </g>
      </g>
      <g>
        <g fill="#000000" opacity="0.5">
          <path d="M406,332H166c-8.284,0-15,6.716-15,15s6.716,15,15,15h240c8.284,0,15-6.716,15-15S414.284,332,406,332z" />
        </g>
      </g>
      <g>
        <g fill="#000000" opacity="0.5">
          <path d="M406,392H166c-8.284,0-15,6.716-15,15s6.716,15,15,15h240c8.284,0,15-6.716,15-15S414.284,392,406,392z" />
        </g>
      </g>
    </svg>
  );
}
